import React, { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import AsyncCreatableSelect from "react-select/async-creatable";

import ai from "../../helpers/axios";

const RegionAutocomplete = ({
  value,
  handleChange,
  options,
  label,
  placeholder,
  required,
  className,
  containerClasses,
}) => {
  const { getAccessTokenSilently, loginWithRedirect } = useAuth0();

  const loadOptions = useCallback(async (inputValue) => {
    const token = await getAccessTokenSilently().catch((e) => {
      console.error(e);
      return loginWithRedirect();
    });

    const { data } = await ai
      .auth(token)
      .get("/api/regions/search", {
        params: {
          q: inputValue,
        },
      });

    return data.map((region) => ({
      value: region.name,
      label: region.name,
    }));
  }, [getAccessTokenSilently, loginWithRedirect]);

  const createOption = useCallback(async (region) => {
    const token = await getAccessTokenSilently().catch((e) => {
      console.error(e);
      return loginWithRedirect();
    });

    const { data } = await ai
      .auth(token)
      .post("/api/regions", {
        name: region,
      });

    handleChange([
      ...(value || []),
      {
        value: data.name,
        label: data.name,
      },
    ]);
  }, [getAccessTokenSilently, loginWithRedirect, value, handleChange]);

  return (
    <div
      className={`form-group  ${
        containerClasses ? containerClasses : ""
      }`}
    >
      <label>
        {label || "Regions"} {required && <span className="required">*</span>}
      </label>

      <AsyncCreatableSelect
        className={`${className ? className : "region-select"} mb-20`}
        classNamePrefix="select"
        loadOptions={loadOptions}
        placeholder={placeholder || "Select an Region(s)"}
        onChange={handleChange}
        isClearable
        isMulti
        cacheOptions
        defaultOptions={options}
        value={value}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        onCreateOption={createOption}
      />
    </div>
  );
};

export default RegionAutocomplete;
